/* eslint-disable react/prop-types */
import { useState, useEffect } from "react";
import Navigation from "../components/Navigation";
import BottomAppBar from "../components/BottomBar";
import { StarsSingleTeam } from "../http/server-apis.js";
import { useParams } from "react-router-dom";
import parse from "html-react-parser";
import Loader from "../components/loaders/Loader";
import { useSelector } from "react-redux";

const SingleTeam = () => {
  const { selectedLanguage } = useSelector((state) => state.Language);
  const [member, setMember] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const params = useParams();
  const { id } = params;

  useEffect(() => {
    async function fetchSingleTeam() {
      try {
        const response = await StarsSingleTeam("post", {
          data: {
            TeamID: id,
            LangCode: selectedLanguage,
          },
        });
        if (response.data.Status === "success")
          setMember(response.data.TeamDetails[0]);
        setIsLoading(false);
      } catch (error) {
        console.log("Something went wrong ");
        setMember([]);
      }
    }
    fetchSingleTeam();
  }, [id, selectedLanguage]);

  

  return (
    <div>
      <Navigation title={member?.Name || "Member"} appBarColor="orange" />
      <div className="fixed-layout-main flex">
        <div className="white-card my-2 ">
          {isLoading ? (
            <Loader />
          ) : (
            <div className="h-[70vh] sm:h-[75vh] overflow-y-scroll">
              <div className="overflow-hidden w-[60%] mx-auto  rounded-3xl">
                <img src={member.Image} alt={member.Name} />
              </div>
              <p className="text-center pt-3 pb-2 text-secondary text-xl font-semibold">
                {member.Name}
              </p>
              <p className="text-center pb-3 text-xs md:text-sm lg:text-sm">
                {member.Designation}
              </p>
              <p className="text-default pb-3 font-semibold lg:text-xl">
                Overview
              </p>
              <p className="text-xs lg:text-sm md:text-sm md:font-normal text-justify leading-4">
                {parse(member.Description)}
              </p>
            </div>
          )}
        </div>
      </div>

      <BottomAppBar />
    </div>
  );
};

export default SingleTeam;
